import React from 'react';
import { Button, Input } from 'semantic-ui-react';

class ConstOrFile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {value : null,
                  type : 'Constant'}

    this.clickHandle = this.clickHandle.bind(this);
  }

  clickHandle(e,d) {
    this.setState({type : d.children});
  }

  render() {
    const current = this.state.type;
    let cAct = true;
    let fAct = false;
    let width = 6;
    let icon = "hashtag";
    if (current==="File") {
      cAct = false;
      fAct = true;
      icon = "file";
      width = 12;
    }

    return(
        <Input fluid icon={icon} iconPosition="right" width={width}
               action={ <Button.Group>
                          <Button active={cAct} onClick={this.clickHandle}>Constant</Button>
                          <Button.Or />
                          <Button active={fAct} onClick={this.clickHandle}>File</Button>
                        </Button.Group>}
              actionPosition="left"/>
    );
  }

}

export default ConstOrFile;